// DD-3769: answers the backend gives when it correctly refuses something. They are not crashes,
// so they get the feedback dialog instead of the full-page error screen, which also clears
// localStorage and reports the error to GlitchTip.
//
// The backend sends the code itself as the GraphQL error message (e.g. NotFoundError('ORDER_NOT_FOUND')).
// Match it exactly: ACCESS_DENIED (no permission) must never be confused with the session error
// "Access denied" (expired login), which logs the user out — see utils/logout.ts.
export type ExpectedErrorFeedback = {
    translationTitleKey: string;
    translationMessageKey: string;
};

const EXPECTED_GRAPHQL_ERRORS: Record<string, ExpectedErrorFeedback> = {
    WORK_ALREADY_STARTED: {
        translationTitleKey: 'WORK_ALREADY_STARTED_TITLE',
        translationMessageKey: 'WORK_ALREADY_STARTED_MESSAGE',
    },
    ORDER_NOT_FOUND: {
        translationTitleKey: 'ORDER_NOT_FOUND_TITLE',
        translationMessageKey: 'ORDER_NOT_FOUND_MESSAGE',
    },
    ACCESS_DENIED: {
        translationTitleKey: 'ACCESS_DENIED_TITLE',
        translationMessageKey: 'ACCESS_DENIED_MESSAGE',
    },
    // DD-3791: an external technician opened an order the lab has not added them to (DD-3391).
    NOT_LINKED_EXTERNAL_USER: {
        translationTitleKey: 'NOT_LINKED_TO_ORDER_TITLE',
        translationMessageKey: 'NOT_LINKED_TO_ORDER_MESSAGE',
    },
};

/** The feedback to show for an expected GraphQL answer, or undefined for anything else. */
export const getExpectedErrorFeedback = (error: unknown): ExpectedErrorFeedback | undefined => {
    const graphQLErrors = (error as { graphQLErrors?: Array<{ message?: unknown }> } | undefined)?.graphQLErrors;
    if (!Array.isArray(graphQLErrors)) return undefined;
    const code = graphQLErrors
        .map((graphQLError) => graphQLError?.message)
        .find((message): message is string => typeof message === 'string' && message in EXPECTED_GRAPHQL_ERRORS);
    return code ? EXPECTED_GRAPHQL_ERRORS[code] : undefined;
};
